import { Link } from "react-router-dom";
import { Download } from "react-feather";
import file_1 from "../../assets/pdf/curriculum_vitae/CV-RYS.pdf";
import file_2 from "../../assets/pdf/curriculum_vitae/CV-LSS.pdf";
import file_3 from "../../assets/pdf/curriculum_vitae/CV-KLS.pdf";
import file_4 from "../../assets/pdf/curriculum_vitae/CV-MMP.pdf";
import file_5 from "../../assets/pdf/curriculum_vitae/CV-BPCC.pdf";
import file_6 from "../../assets/pdf/curriculum_vitae/CV-JRS.pdf";
import file_9 from "../../assets/pdf/curriculum_vitae/CV-RJP.pdf";

const FilesDataBOD = [
  {
    name: "Atty. Rene Y. Soriano",
    file: file_1,
  },
  {
    name: "Atty. Lea S. Soriano",
    file: file_2,
  },
  {
    name: "Atty. Kathryn Leia S. Soriano-Posadas",
    file: file_3,
  },
  {
    name: "Ms. Merlita M. Primo",
    file: file_4,
  },
  {
    name: "Atty. Bernard Philip C. Claustro",
    file: file_5,
  },
  {
    name: "Mr. Josef Ryan S. Soriano",
    file: file_6,
  },
  {
    name: "Mr. Reynato J. Primo",
    file: file_9,
  },
];

// const FilesDataManager = [
//   {
//     name: "Harold D. Marentes",
//     file: file_10,
//   },
//   {
//     name: "Ms. Alma Sanmocte",
//     file: file_11,
//   },
//   {
//     name: "Ilen Oquendo",
//     file: file_12,
//   },
// ];

const CurriculumVitae = () => {
  return (
    <div className='main-container'>
      <h1 class='title'>CV for Board of Directors</h1>
      <div id='containerCV'>
        {FilesDataBOD.map((fileDetails, index) => {
          return (
            <div className='row'>
              <div className='row-title'>
                <div className='link'>{fileDetails.name}</div>
              </div>
              <Link to={fileDetails.file} target='_blank'>
                <div className='row-text'>
                  <Download />
                </div>
              </Link>
            </div>
          );
        })}
      </div>
      {/* <h1 class='title'>CV for Managers</h1>
      <div id='containerCV'>
        {FilesDataManager.map((fileDetails, index) => {
          return (
            <div className='row'>
              <div className='row-title'>
                <div className='link'>{fileDetails.name}</div>
              </div>
              <Link to={fileDetails.file} target='_blank'>
                <div className='row-text'>
                  <Download />
                </div>
              </Link>
            </div>
          );
        })}
      </div> */}
    </div>
  );
};

export default CurriculumVitae;